module.exports = function(dispatcher) {
  return function(view) {
    dispatcher.dispatch({
      type: 'updateView',
      view
    });
  };
};